module.exports = __webpack_public_path__ + "img/xinxi-bg.79601ab3.png";